import { FC } from 'react'
import useFiltersForm from '../../../../../hooks/forms/use-filters-form'
import { Button, DatePicker, Form, InputNumber, Table } from 'antd'
import { ClearOutlined } from '@ant-design/icons'
import { outputDateFormat } from '../../../../../constants/constants'
import User from '../../../../../components/form-items/user/user'
import MaterialTypes from '../../../../../components/form-items/material-types/material-types'

interface FiltersFormProps {}

const FiltersForm: FC<FiltersFormProps> = () => {
    const { form, onSearch, onClear } = useFiltersForm()

    return (
        <Form
            form={form}
            component={false}
            variant={'filled'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <Table.Summary.Cell index={0}></Table.Summary.Cell>
            <Table.Summary.Cell index={0}></Table.Summary.Cell>
            <Table.Summary.Cell index={1}>
                <Form.Item name={'createdAt'} noStyle>
                    <DatePicker placeholder={'Дата'} format={outputDateFormat} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2}>
                <MaterialTypes rules={[]} noStyle />
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3}>
                <Form.Item name={'width'} noStyle>
                    <InputNumber step={10} placeholder={'Ширина'} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} />
            <Table.Summary.Cell index={5}>
                <User name={'createdBy'} placeholder={'Пользователь'} noStyle />
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6}>
                <Button
                    size={'small'}
                    icon={<ClearOutlined />}
                    title={'Сбросить фильтры'}
                    onClick={onClear}
                >
                    Сброс
                </Button>
            </Table.Summary.Cell>
        </Form>
    )
}

export default FiltersForm
